const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "16%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "8%"
  },
  {
    key: "exhaustPressure",
    zh: "排气压力(MPa)",
    en: "Exhaust Pressure(MPa)",
    width: "11%",
    tooltip: true
  },
  {
    key: "oilDrumPressure",
    zh: "油分桶压力(MPa)",
    en: "Oil Drum Pressure(MPa)",
    width: "11%",
    tooltip: true
  },
  {
    key: "outputCurrent",
    zh: "输出电流(A)",
    en: "Output Current(A)",
    width: "12%",
    tooltip: true
  },
  {
    key: "outputFrequency",
    zh: "频率(Hz)",
    en: "Output Frequency(Hz)",
    width: "10%",
    tooltip: true
  },
  {
    key: "ratedFrequency",
    zh: "上限频率(Hz)",
    en: "Rated Frequency(Hz)",
    width: "9%",
    tooltip: true
  },
  {
    key: "percentage",
    zh: "占比",
    en: "Percentage",
    width: "9%",
    tooltip: true
  }
]

export default columns